import React, { useState } from 'react';
import { Box, Paper, Typography, Button, TextField } from '@mui/material';
import { useDashboard } from '../../../contexts/DashboardContext';

interface MastitisAnimalIdStepProps {
  initialData?: any;
}

const MastitisAnimalIdStep: React.FC<MastitisAnimalIdStepProps> = ({ initialData }) => {
  const { updateContent } = useDashboard();
  const [animalId, setAnimalId] = useState<string>(initialData?.mastitis?.animalId || '');

  const handleNext = () => {
    const payload = {
      ...(initialData || {}),
      mastitis: {
        ...(initialData?.mastitis || {}),
        animalId: animalId?.trim() || null,
      },
    };
    updateContent('mastitisTestStep1', payload);
  };

  const handleCancel = () => {
    updateContent('welcome');
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Identificação do Animal</Typography>
        <Button variant="text" size="small" onClick={handleCancel} sx={{ color: 'text.secondary', textTransform: 'none' }}>
          Cancelar
        </Button>
      </Box>

      {/* Content */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Paper
          elevation={0}
          sx={(theme) => ({
            p: 2,
            width: '100%',
            maxWidth: 720,
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.default,
          })}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
            Informe a identificação do animal relacionado ao teste de mastite. Pode ser número de brinco, nome ou outra referência utilizada na fazenda.
          </Typography>
          <TextField
            fullWidth
            label="Identificação do animal"
            placeholder="Brinco 855, Mimosa"
            value={animalId}
            onChange={(e) => setAnimalId(e.target.value)}
            size="small"
          />

          {/* Ações */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, width: '100%', mt: 2 }}>
            <Button variant="outlined" onClick={handleCancel} sx={{ textTransform: 'none' }}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{ textTransform: 'none', color: '#fff !important', '&:hover': { color: '#fff !important' } }}
            >
              Próximo
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default MastitisAnimalIdStep;